import React from 'react'
import { Form, Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Actions from '../../../../actions'
import { routes } from '../../../../consts'
import { ProfileRoutes } from '../../../../consts/Profile'
import MaterialInput from '../../../common/MaterialInput/MaterialInput'
import Page from '../../../common/Page/Page'
import PageCard from '../../../common/PageCard'

import './ResetPassword.css'
import { event, eventTypes } from '../../../../consts/eventConsts'

const ResetPassword = () => {
  const [form] = Form.useForm()
  const phoneNumberRegex = /^\d{10}$/

  const dispatch = useDispatch()

  const { resetPassword, errorMessage } = useSelector(state => state.auth)
  const { loading, isCodeSentToPhoneFailure } = resetPassword

  const isAuthenticated = useSelector(state => state.auth.isLoggedIn)
  const handleNext = values => {
    const phone = `+${values.phoneNumber.code}${values.phoneNumber.phone}`
    dispatch(
      Actions.createAction(Actions.OTP_CODE_REQUESTED, {
        phone,
        route: isAuthenticated
          ? ProfileRoutes.PROFILE_RESET_PASSWORD_VERIFY_CODE
          : routes.RESET_PASSWORD_VERIFY_CODE,
      })
    )
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.formEvent,
        eventName: event.formEvent.submit,
        data: { phone },
        element: 'Forgot password',
      })
    )
  }

  const validatePhoneNumber = (rule, value) => {
    const isValidPhoneNumber = phoneNumberRegex.test(value.phone)
    if (!isValidPhoneNumber) {
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.formEvent,
          eventName: event.formEvent.invalid,
          data: { phone: value?.phone },
          element: 'Forgot password',
        })
      )
      return Promise.reject(
        $t('pages.getStarted.signupForm.errors.pleaseInputValidPhoneNumber')
      )
    }
    return Promise.resolve()
  }
  return (
    <PageCard className="forgot-password-page-card login-page-card">
      <Page
        hideAlertBanner={true}
        className="login-page"
        title={$t('pages.getStarted.resetPassword.resetPassword')}
        subtitle={
          <>
            {$t('pages.getStarted.resetPassword.resetPasswordDescription1')}
            <br />{' '}
            {$t('pages.getStarted.resetPassword.resetPasswordDescription2')}
          </>
        }
      >
        <div className="reset-password-container">
          <Form
            className="reset-password-form"
            onFinish={handleNext}
            name="basic"
            initialValues={{
              phoneNumber: {
                code: 1,
                phone: '',
                short: 'US',
              },
            }}
            form={form}
          >
            <div className="reset-password-form-item-container">
              <Form.Item
                className="reset-password-form-item"
                name={'phoneNumber'}
                type="text"
                rules={[{ validator: validatePhoneNumber }]}
              >
                <MaterialInput
                  label={$t('pages.getStarted.signupForm.phoneNumber')}
                  placeholder={$t(
                    'pages.getStarted.signupForm.phoneNumberText'
                  )}
                  type="phone"
                />
              </Form.Item>
              <div className="error-message">
                {isCodeSentToPhoneFailure ? errorMessage : null}
              </div>
            </div>
            <Form.Item className="">
              <Button
                loading={loading}
                type="primary"
                className=""
                htmlType="submit"
              >
                {$t('pages.getStarted.resetPassword.next')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Page>
    </PageCard>
  )
}

export default ResetPassword
